import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  // Async sagas
  checkAuth: ['credentials'],
  requestLogin: ['credentials'],
  requestRecover: ['user'],
  requestLoginByGuid: ['guid'],
  // Reducers
  successAuth: ['accessToken'],
  successLogin: ['action'],
  failureLogin: ['error'],
  successRecover: [],
  failureRecover: ['error'],
  logout: [],
  handleLogout: [],
  refreshToken: ['token'],
  loadingAuth: ['loading'],
});

export const AuthTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE = Immutable({
  access_token: '',
  isAuthenticated: false,
  error: false,
  keepConnected: false,
  loading: {
    checkingAuth: false,
    requestingLogin: false,
  },
});

/* Reducers */
const successAuth = (state = INITIAL_STATE, action) => {
  const accessToken = action.data;
  const authenticatedState = {
    ...state,
    access_token: accessToken,
    isAuthenticated: true,
    error: false,
  };
  return authenticatedState;
};

const successLogin = (state = INITIAL_STATE, { data }) => {
  const {
    keepConnected,
    user: { access_token: AccessToken },
  } = data;
  return {
    ...state,
    access_token: AccessToken,
    isAuthenticated: true,
    error: false,
    keepConnected,
  };
};

const failureLogin = (_state = INITIAL_STATE, { errorData }) => ({
  ...INITIAL_STATE,
  error: errorData,
});
const handleLogout = () => ({ ...INITIAL_STATE });

const refreshToken = (state = INITIAL_STATE, { token }) => {
  if (token) {
    return {
      ...state,
      access_token: token,
      isAuthenticated: true,
    };
  }
  return { ...state, isAuthenticated: false };
};

const loadingAuth = (state = INITIAL_STATE, { loading }) => ({
  ...state,
  loading: {
    ...state.loading,
    ...loading,
  },
});

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SUCCESS_AUTH]: successAuth,
  [Types.SUCCESS_LOGIN]: successLogin,
  [Types.FAILURE_LOGIN]: failureLogin,
  [Types.HANDLE_LOGOUT]: handleLogout,
  [Types.REFRESH_TOKEN]: refreshToken,
  [Types.LOADING_AUTH]: loadingAuth,
});
